import { useRef, useImperativeHandle, forwardRef, useEffect, useState } from "react";
import { Box } from "@mui/material";
import "./index.scss";

interface ISimpleEditor {
    value: string;
    onValueChange: (value: string) => void;
    options: {
        wrapText: boolean;
        [key: string]: any;
    };
}

const SimpleEditor = forwardRef((props: ISimpleEditor, ref) => {
    const { value, onValueChange, options } = props;
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [localValue, setLocalValue] = useState(value);

    // Sync local value with prop value when it changes (e.g. on fetch or reset)
    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    useImperativeHandle(ref, () => ({
        getValue: () => localValue,
        setValue: (val: string) => setLocalValue(val),
    }));

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newVal = e.target.value;
        setLocalValue(newVal);
        onValueChange(newVal);
    };

    return (
        <Box className="simple-editor-container h-full w-full">
            <textarea
                ref={textAreaRef}
                value={localValue}
                onChange={handleChange}
                spellCheck={false}
                autoCorrect="off"
                autoCapitalize="off"
                style={{
                    whiteSpace: options.wrapText ? "pre-wrap" : "pre",
                    overflowX: options.wrapText ? "hidden" : "auto",
                }}
                className="simple-editor-textarea"
                placeholder="Type your notes here..."
            />
        </Box>
    );
});

export default SimpleEditor;
